import { Heading } from '@chakra-ui/react'

import { Section } from '../components/Section'
import { Container } from '../components/Container'
import { AppSelector } from '../containers/AppSelector'
import { useAuth } from '../context/AuthContext'
import { WithAuth } from '../containers/hoc/WithAuth'
import { PageContent } from '../containers/PageContent'

const _IndexPage = () => {
  const { user } = useAuth() ?? {}

  return (
    <PageContent sx={{ alignContent: 'center', my: 8 }}>
      <Section>
        <Container>
          <Heading
            as="h1"
            sx={{
              letterSpacing: 'tighter',
              textAlign: 'center',
              mb: { base: 4, xl: 8 },
              fontSize: {
                base: '4xl',
                xl: '5xl',
              },
              fontWeight: 'bold',
            }}
          >
            Vítejte {user?.userFullName}!
          </Heading>

          <AppSelector />
        </Container>
      </Section>
    </PageContent>
  )
}

export const IndexPage = WithAuth(_IndexPage)